(function () {
  if (window.__ipackSwatches) return;
  window.__ipackSwatches = true;
  function apply(btn) {
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('.card__media .media > img');
    if (img && btn.dataset.src) {
      img.removeAttribute('loading');
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.src;
      card.classList.add('ipack-swatched');
    }
    card.querySelectorAll('.ipack-sw__dot').forEach(function (d) {
      var on = d === btn;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (btn.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link, a.product__view-details').forEach(function (a) { a.href = btn.dataset.url; });
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ipack-sw__dot');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    apply(b);
  }, true);
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('.ipack-sw__dot');
      if (b && !b.classList.contains('is-active')) apply(b);
    });
  }
})();
